import { render, staticRenderFns } from "./Availability.vue?vue&type=template&id=497a67d1&scoped=true"
import script from "./Availability.vue?vue&type=script&lang=js"
export * from "./Availability.vue?vue&type=script&lang=js"
import style0 from "./Availability.vue?vue&type=style&index=0&id=497a67d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497a67d1",
  null
  
)

export default component.exports